import { render, staticRenderFns } from "./StatManagement.vue?vue&type=template&id=3b5d5fee&scoped=true"
import script from "./StatManagement.vue?vue&type=script&lang=js"
export * from "./StatManagement.vue?vue&type=script&lang=js"
import style0 from "./StatManagement.vue?vue&type=style&index=0&id=3b5d5fee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5d5fee",
  null
  
)

export default component.exports